import { ApprovedQcPlan } from '../../../contracts/qc-plan/approved-qc-plan.model';

export interface IApprovedQcPlanState {
    qcPlans: ApprovedQcPlan[];
}

const initialState: IApprovedQcPlanState = {
    qcPlans: [],
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/IApprovedQcPlanState.ts